import api from "../common/services/liferay/api";
import {Liferay} from "../common/services/liferay/liferay";

export const deleteCoordinationSettings = async (jsonConfigurateAuthType) => {

    let url = `/api/jsonws/invoke`;

    const resp = await api(url, {
        method: 'POST',
        body: new URLSearchParams({
            cmd: JSON.stringify({
                '/digitalsale.deliverycoordinationsetting/delete': jsonConfigurateAuthType,
            }),
            p_auth: Liferay.authToken
        }),
    });

    const data = await resp.json();

    return JSON.parse(data);
}